export const eventTypes = {
    VIEW_CONTROLS: 'vControls',
    DOM_EVENTS: 'domEvents',
    VIEWER_EVENTS: 'viewerEvents'
}

export const events = {
    /* VIEW CONTROL (GUI to Viewer) */
    ZOOM_IN_EVENT: 'zoomIn',
    ZOOM_OUT_EVENT: 'zoomOut',
    SLIDER_EVENT: 'slider',
    SET_CAMERA_EVENT: 'set-camera',
    FIT_CONTENT_EVENT: 'fit-content',
    SET_ANIMATION_EVENT: 'set-animation',
    SWITCH_CAMERA_EVENT: 'switch-camera',
    SET_CURRENT_SCENE_EVENT: 'set-current-scene',
    EXPORT_GLB_EVENT: 'export-glb',
    // unused (yet)
    AUGMENTED_REALITY_EVENT: 'augmented',

    // DOM Event
    VIEW_OFFSET_EVENT: 'view-offset',

    /* VIEW NOTIFICATION (Viewer to GUI) */
    CAMERA_CHANGE: 'camera-change',
    SELECT_EVENT: 'select',
    EMPTYSELECT_EVENT: 'empty-select',
    MOVE_GROUP: 'move-group',
    LAYOUT_RESULTS: 'layout-results',
    LOADING: 'viewer-loading'
}

let subsId = 1;

type EventCallbackFn = (event: string, data: any) => void;

type Subscription = {
    id: number;
    callback: EventCallbackFn
}

type EventObject = {
    [event: string]: Subscription[];
}

type EventEmitterType = {
    events: EventObject;
    dispatch: (eventType: string, event: string, data?: any) => void
    subscribe: (eventType: string, callback: EventCallbackFn) => number
    unsubscribe: (eventType: string, id: number) => void
}

export const EventEmitter: EventEmitterType = {

    events : {},    

    dispatch : function(eventType, event, data){
        if(!this.events[eventType]) return;
        this.events[eventType].forEach(subscription => subscription.callback(event, data));
    },

    subscribe : function(eventType, callback){
        let id = subsId++;
        if(!this.events[eventType]) this.events[eventType] = [];
        this.events[eventType].push({ id, callback });
        return id;
    },

    unsubscribe : function(eventType, id){
        if(!this.events[eventType]) return;
        this.events[eventType] = this.events[eventType].filter(subscription => subscription.id !== id);
    }
}